<template>
  <member v-if="isGpsAvailable" v-bind="$props" />
  <member-for-report v-else />
</template>

<script>
import TheMember from '@/views/TheMember.vue'
import TheMemberForReport from '@/views/TheMemberForReport.vue'
import { FUNCTION_TYPE } from '@/constants.js'

/**
 * TheMemberの表示切り分け用ラッパーview
 * FIXME:TheMember内で機能タイプにより切り分け
 */
export default {
  name: 'TheMemberDispatch',
  components: {
    'member': TheMember,
    'member-for-report': TheMemberForReport,
  },
  props: {
    /**
     * プレイスID
     */
    placeId: {
      type: Number,
      default: null,
    },
    /**
     * フロアID
     */
    indoorLevelId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    /**
     * 定期位置通知が利用可能か？
     * @type {Boolean}
     */
    isGpsAvailable: function () {
      return !!this.$store.getters.functionType(FUNCTION_TYPE.GPS)
    },
  },
}
</script>
